import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { Spinner, Alert } from 'reactstrap';

import ProfileForm from '../../components/Profile/ProfileForm';
import * as url from '../../helpers/url_helper';
import { get } from '../../helpers/api_helper';

// eslint-disable-next-line no-unused-vars
function SaveProfile(props) {
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [entity, setEntity] = useState(false);

  const { id } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const profile = await get(url.GET_PROFILE.replace(/:id/, id));

        setEntity(profile);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };

    if (id !== undefined) {
      setLoading(true);
      fetchData();
    }
  }, []);

  const onSuccess = () => {
    history.goBack();
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        {loading === true && (
          <div>
            <Spinner style={{ width: '4rem', height: '4rem' }} type="border" color="info" />
          </div>
        )}
        {error !== false && (
          <Alert color="danger" className="mt-3" isOpen>
            {error}
          </Alert>
        )}
        {entity !== false && (
          <ProfileForm
            actionUrl={url.POST_PROFILE}
            entity={entity}
            onSuccess={onSuccess}
          />
        )}
        {entity === false && loading === false && error === false && (
          <ProfileForm
            actionUrl={url.POST_PROFILE}
            onSuccess={onSuccess}
          />
        )}
      </div>
    </div>
  );
}

SaveProfile.defaultProps = {
  t: (x) => (x),
};

SaveProfile.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(SaveProfile));
